import React from 'react';
import styled from 'styled-components';
import { PREPROD_PREVIEW_ACTIONS } from './context/types';
import { usePreproductPreviewContext } from './context/Context';
import { useModalOverlay } from './hooks/useModalOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
var overlayVisibleStyles = "\n    opacity: 1;\n    pointer-events: auto;\n";
export var OverlayComponent = styled.div.attrs({
  role: 'presentation'
}).withConfig({
  displayName: "Overlay__OverlayComponent",
  componentId: "sc-14o9du1-0"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(var(--wcds-colors-black-rgb),0.8);z-index:998;opacity:0;pointer-events:none;transition:opacity 0.3s ease-in-out;", ""], function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible && overlayVisibleStyles;
});
export var Overlay = function Overlay() {
  var _usePreproductPreview = usePreproductPreviewContext(),
      dispatch = _usePreproductPreview.dispatch,
      boardContainerState = _usePreproductPreview.boardContainerState;

  useModalOverlay(boardContainerState.boardContainerDisplayMode === 'modal');

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    dispatch({
      type: PREPROD_PREVIEW_ACTIONS.SET_BOARD_CONTAINER_DISPLAY_MODE,
      payload: 'inline'
    });
  };

  return /*#__PURE__*/_jsx(OverlayComponent, {
    isVisible: boardContainerState.boardContainerDisplayMode === 'modal',
    onClick: handleClick
  });
};